import AnyAction from 'store/anyActions';
import AnnouncementState from './announcement.state';
import AnnouncementTypes from './announcement.types';

const defaultState = {
    announcementsOpen: false,
    userAnnouncements: undefined,
    unreadUserAnnouncements: undefined,
}

export default function (state: AnnouncementState = defaultState, action: AnyAction): AnnouncementState | null {
    switch (action.type) {
        case AnnouncementTypes.GET_USER_ANNOUNCEMENTS:
            return {
                ...state,
                userAnnouncements: action.payload,
            };
        case AnnouncementTypes.GET_UNREAD_USER_ANNOUNCEMENTS:
            return {
                ...state,
                unreadUserAnnouncements: action.payload,
            };
        case AnnouncementTypes.GET_ANNOUNCEMENTS:
            return {
                ...state,
                announcements: action.payload,
                announcementsLoading: false
            };
        case AnnouncementTypes.GET_ANNOUNCEMENTS_ERROR:
            return {
                ...state,
                announcementsLoading: false,
                announcementsError: true,
            };
        case AnnouncementTypes.GET_ANNOUNCEMENTS_LOADING:
            return {
                ...state,
                announcementsLoading: true
            };
        case AnnouncementTypes.UPDATE_ANNOUNCEMENT_LOADING:
            return {
                ...state,
                updateAnnouncementsLoading: true
            };
        case AnnouncementTypes.UPDATE_ANNOUNCEMENT:
            return {
                ...state,
                announcements: state.announcements?.map(
                    ann => ann.ID === action.payload.ID ?
                    {
                        ...ann,
                        ...action.payload
                    } :
                    ann
                )
            };
        case AnnouncementTypes.UPDATE_USER_ANNOUNCEMENT:

            console.log('action', action)
            return {
                ...state,
                userAnnouncements: state.userAnnouncements?.map(
                    ua => ua.ID === action.payload.ID ?
                    {
                        ...ua,
                        ...action.payload
                    } :
                    ua
                ),
                unreadUserAnnouncements: state.unreadUserAnnouncements?.filter(
                    ua => ua.ID === action.payload.ID ?
                    !action.payload.read :
                    true
                )
            };
        case AnnouncementTypes.UPDATE_USER_ANNOUNCEMENT_LOADING:
            return {
                ...state,
                updateUserAnnouncementsLoading: true
            };
        case AnnouncementTypes.DELETE_ANNOUNCEMENT:
            return {
                ...state,
                announcements: state.announcements?.filter(ann => ann.ID !== action.payload)
            };
        default:
            return state;
    }
}
